'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _loveButton = require('../loveButton.js');

var _loveButton2 = _interopRequireDefault(_loveButton);

var _fullscreenSocialDownload = require('../fullscreenSocialDownload.js');

var _fullscreenSocialDownload2 = _interopRequireDefault(_fullscreenSocialDownload);

var _utils = require('../../utils');

var _fullscreenCartIcon = require('../fullscreenCartIcon.js');

var _fullscreenCartIcon2 = _interopRequireDefault(_fullscreenCartIcon);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _shareStore = require('-!svg-react-loader!../../assets/images/fullscreen-store/share-store.svg');

var _shareStore2 = _interopRequireDefault(_shareStore);

var _closeXMobile = require('-!svg-react-loader!../../assets/images/fullscreen-store/close-x-mobile.svg');

var _closeXMobile2 = _interopRequireDefault(_closeXMobile);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenMobileBarV2 = function (_React$Component) {
  (0, _inherits3.default)(FullscreenMobileBarV2, _React$Component);

  function FullscreenMobileBarV2(props) {
    (0, _classCallCheck3.default)(this, FullscreenMobileBarV2);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenMobileBarV2.__proto__ || (0, _getPrototypeOf2.default)(FullscreenMobileBarV2)).call(this, props));

    _this.state = {
      showShare: false
    };

    _this.sampleInput = {
      love: {
        onClick: function onClick() {},
        text: '1'
      }
    };
    return _this;
  }

  (0, _createClass3.default)(FullscreenMobileBarV2, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      if (_utils.utils.isStoreGallery()) {
        var providerId = _utils.utils.getProviderFromGalleryInfo(newProps.galleryInfo);
        new _promise2.default(function (resolve) {
          require.ensure([], function (require) {
            resolve(require('@wix/pro-gallery-artstore-statics'));
          });
        }).then(function (cart) {
          cart.cartApi.getCartItems(providerId).then(function (arrItems) {
            var count = cart.cartApi.getCartItemsCount(arrItems);
            _this2.setState({ cartItemsCount: count });
          });
        });
      }
    }
  }, {
    key: 'getLoveButton',
    value: function getLoveButton() {
      var _props = this.props,
          styleParams = _props.styleParams,
          love = _props.love;

      var props = _lodash2.default.pick(this.props, ['itemId', 'id', 'item', 'idx', 'styleParams', 'love', 'hashtag']);
      return styleParams.loveButton ? _react2.default.createElement(_loveButton2.default, (0, _extends3.default)({}, props, {
        layout: 'fullscreen',
        device: 'mobile',
        showCounter: true
      })) : '';
    }
  }, {
    key: 'getDownloadButton',
    value: function getDownloadButton() {
      var _props2 = this.props,
          current = _props2.current,
          styleParams = _props2.styleParams;

      return _react2.default.createElement(_fullscreenSocialDownload2.default, {
        layout: 'fullscreen',
        device: 'mobile',
        current: current,
        styleParams: styleParams
      });
    }
  }, {
    key: 'getCartButton',
    value: function getCartButton() {
      return _utils.utils.isStoreGallery() ? _react2.default.createElement(_fullscreenCartIcon2.default, { cartItemsCount: this.state.cartItemsCount }) : false;
    }
  }, {
    key: 'getShareContainer',
    value: function getShareContainer() {
      var _this3 = this;

      var shareButton = this.props.styleParams.allowSocial ? _react2.default.createElement(
        'button',
        {
          className: 'pro-fullscreen-share-icon',
          onClick: function onClick() {
            return _this3.props.actions.toggleShareScreen();
          }
        },
        (0, _shareStore2.default)()
      ) :
      // <i className='progallery-svg-font-icons-share-store pro-fullscreen-share-icon' onClick={() => this.props.actions.toggleShareScreen()}/>
      false;

      return _react2.default.createElement(
        'div',
        { className: 'fullscreen-social' },
        this.getDownloadButton(),
        this.getCartButton(),
        this.getLoveButton(),
        shareButton
      );
    }
  }, {
    key: 'getTopMobileBar',
    value: function getTopMobileBar() {
      var _this4 = this;

      var mobileTopClassNames = (0, _classnames2.default)('fullscreen-mobile-bar', 'fullscreen-mobile-top', 'pro-fullscreen-store', 'fixed-items', {
        share: this.state.showShare
      });

      return _react2.default.createElement(
        'div',
        { className: mobileTopClassNames },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('button', {
            className: 'fullscreen-close progallery-svg-font-icons-back',
            onClick: function onClick() {
              return _this4.props.actions.close(_this4.props.current.idx);
            }
          }),
          this.getShareContainer()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var mobileBars = [];
      if (_utils.utils.isSmallScreen()) {
        mobileBars[0] = this.getTopMobileBar();
        mobileBars[1] = false;
      }
      var res = this.props.isFirst ? mobileBars[0] || false : mobileBars[1] || false;
      return res;
    }
  }]);
  return FullscreenMobileBarV2;
}(_react2.default.Component);

exports.default = FullscreenMobileBarV2;